enum MODE_TYPES {
  LIGHT = "light",
  DARK = "dark",
}

export { MODE_TYPES };
